import axios from "../config/axiosInstance";
import endpoints from "./endpoints";

export const getApplicationReports = async (details) => {
  const response = await axios.put(endpoints.getAllCategory, details);
  return response;
};

export const RetrieveItemGroups = async (id) => {
  const response = await axios.get(endpoints.RetrieveInventoryItemGroups(id));
  return response;
};

// export const getDoctorsForApplicationSale = async (details) => {
//   const response = await axios.get(endpoints.getDoctors, details);
//   return response;
// };

export const getDoctorsForApplicationSale = async (details) => {
  const response = await axios.get(endpoints.getDoctors, {
    params: details, // This serializes your details object to query params
  });
  return response;
};

export const getApplicationReportHeaderDetails = async (details) => {
  const response = await axios.put(
    endpoints.getApplicationReportHeaderDetailsURL,
    details
  );
  return response;
};

export const getUserDetailsForApplicationSale = async (details) => {
  const response = await axios.get(endpoints.getUserDetails, {
    params: details, // This serializes your details object to query params
  });
  return response;
};
